// extracted by mini-css-extract-plugin
export default {"panesliderOverlay":"style_panesliderOverlay__nlc6D","open":"style_open__v-HRW","panelSlide":"style_panelSlide__BWTDx","close":"style_close__If9DW","closebtn":"style_closebtn__Xi4KY"};